import styled from 'styled-components';

export const TitleContainer = styled.div`
  text-align: center;
`;
